<template>
  <footer class="web-footer">
    <div class="container">
      <div class="footer-grid">
        <div class="footer-column"> 
          <div class="logo-container">
            <i class="logo-icon"></i>
            <span class="logo-text">安徽经纶瑞恒医药科技有限公司</span>
          </div>
          <p class="footer-description">
            致力于提供最优质的医疗服务，推动医学进步，守护患者健康。
          </p>
          <!-- <div class="social-links">
            <a href="#" class="social-link">
              <i class="wechat-icon"></i>
            </a>
            <a href="#" class="social-link">
              <i class="weibo-icon"></i>
            </a>
            <a href="#" class="social-link">
              <i class="linkedin-icon"></i>
            </a>
          </div> -->
        </div>

        <div class="footer-column">
          <h3 class="footer-heading">快速链接</h3>
          <ul class="footer-links">
            <li><a href="#about" class="footer-link">关于我们</a></li>
            <li><a href="#features" class="footer-link">企业特色</a></li>
            <li><a href="#culture" class="footer-link">企业文化</a></li>
            <li><a href="#recruitment" class="footer-link">患者招募</a></li>
          </ul>
        </div>

        <div class="footer-column">
          <h3 class="footer-heading">联系我们</h3>
          <ul class="contact-info">
            <li class="contact-item">
              <i class="location-icon"></i>
              <span class="contact-text">安徽省合肥市高新区汇景城市中心C栋1202</span>
            </li>
            <li class="contact-item">
              <i class="phone-icon"></i>
              <span class="contact-text">400-123-4567</span>
            </li>
            <li class="contact-item">
              <i class="email-icon"></i>
              <span class="contact-text">songsong_0556@126.com</span>
            </li>
          </ul>
        </div>

        <div class="footer-column">
          <h3 class="footer-heading">工作时间</h3>
          <ul class="working-hours">
            <li class="hours-item">
              <span class="day">周一至周五</span>
              <span class="time">9:00 - 18:00</span>
            </li>
          
            <li class="hours-item">
              <span class="day">周六日</span>
              <span class="time">休息</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="copyright">© {{ currentYear }} 安徽经纶瑞恒医药科技有限公司. 保留所有权利。</p>
        <p class="beian">
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">皖ICP备2024071542号-3</a>
          <span class="separator">|</span>
          <img src="@/assets/jh.png" alt="公安备案图标" class="beian-icon">
          <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34019202002632" target="_blank" rel="noopener noreferrer">皖公网安备34019202002632号</a>
        </p>
      </div>
      </div>
  </footer>
</template>

<script setup>
// 直接定义常量，无需响应式引用
const currentYear = new Date().getFullYear()
</script>

<style scoped>
.web-footer {
  background-color: #111827;
  color: white;
  padding-top: 2.5rem; /* 移动端减小顶部内边距 */
  padding-bottom: 2rem;
}

.container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
  box-sizing: border-box; /* 确保padding不增加总宽度 */
}

@media (min-width: 640px) {
  .container {
    padding: 0 1.5rem;
  }
}

@media (min-width: 1024px) {
  .container {
    padding: 0 2rem;
    padding-top: 1rem;
  }
}

.footer-grid {
  display: grid;
  grid-template-columns: 1fr; /* 移动端单列布局 */
  gap: 2rem; /* 移动端列间距 */
  margin-bottom: 2rem; /* 减小底部间距 */
}

/* 平板设备：2列布局 */
@media (min-width: 640px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2.5rem;
  }
}

/* 桌面设备：4列布局 */
@media (min-width: 1024px) {
  .footer-grid {
    grid-template-columns: repeat(4, 1fr);
    margin-bottom: 3rem;
  }
}

.footer-column {
  display: flex;
  flex-direction: column;
  padding: 0 0.5rem; /* 增加内边距防止内容贴边 */
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 0.5rem; /* 修复原代码的space-x语法错误 */
  margin-bottom: 1rem;
}

.logo-icon {
  font-size: 1.5rem;
  color: #60a5fa;
}

.logo-text {
  font-size: 1.25rem;
  font-weight: 700;
}

.footer-description {
  color: #9ca3af;
  margin-bottom: 1rem;
  line-height: 1.6; /* 增加行高提高可读性 */
  font-size: 0.95rem; /* 移动端稍小字体 */
}

.social-links {
  display: flex;
  gap: 1rem; /* 修复原代码的space-x语法错误 */
  margin-bottom: 1rem; /* 增加底部间距 */
}

.social-link {
  color: #9ca3af;
  transition: color 0.2s ease;
  width: 2.5rem; /* 增大点击区域 */
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-link:hover {
  color: #60a5fa;
}

.footer-heading {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 1rem;
  position: relative;
  padding-bottom: 0.5rem;
}

.footer-heading::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 2rem;
  height: 2px;
  background-color: #60a5fa;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 0.75rem; /* 修复原代码的space-y语法错误 */
  padding-left: 0;
  margin: 0;
  list-style: none;
}

.footer-link {
  color: #9ca3af;
  transition: color 0.2s ease;
  text-decoration: none;
  font-size: 0.95rem;
  display: inline-block;
  padding: 0.25rem 0;
}

.footer-link:hover {
  color: #60a5fa;
  transform: translateX(3px);
  transition: transform 0.2s ease;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem; /* 修复原代码的space-y语法错误 */
  padding-left: 0;
  margin: 0;
  list-style: none;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  word-break: break-word; /* 防止长文本溢出 */
}

.contact-item:first-child {
  align-items: flex-start;
}

.location-icon {
  color: #60a5fa;
  margin-top: 0.25rem;
  margin-right: 0.75rem;
  flex-shrink: 0;
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'%3E%3Cpath fill='%2360a5fa' d='M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 72c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8s-8-3.6-8-8V80c0-4.4 3.6-8 8-8zm0 96c4.4 0 8 3.6 8 8v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V176c0-4.4 3.6-8 8-8z'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
}

.phone-icon {
  color: #60a5fa;
  margin-right: 0.75rem;
  flex-shrink: 0;
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%2360a5fa' d='M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96.4-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96.4z'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
}
.email-icon {
  color: #60a5fa;
  margin-right: 0.75rem;
  flex-shrink: 0; /* 防止图标被压缩 */
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%2360a5fa' d='M48 64C48 28.7 76.7 0 112 0h288c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H112c-35.3 0-64-28.7-64-64V64zm32 0v384c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32zM160 128c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V128zm-32 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
}

.contact-text {
  color: #9ca3af;
  line-height: 1.6;
  font-size: 0.95rem;
}

/* 优化地址显示 */
.contact-item:first-child .contact-text {
  line-height: 1.6;
}

.working-hours {
  display: flex;
  flex-direction: column;
  gap: 0.75rem; /* 修复原代码的space-y语法错误 */
  padding-left: 0;
  margin: 0;
  list-style: none;
}

.hours-item {
  display: flex;
  justify-content: space-between;
  font-size: 0.95rem;
}

.day,
.time {
  color: #9ca3af;
}

.day {
  flex: 1;
}

.time {
  text-align: right;
  flex: 1;
}

.footer-bottom {
  border-top: 1px solid #1f2937;
  padding-top: 1.5rem; /* 减小顶部内边距 */
  text-align: center;
}

.copyright {
  color: #6b7280;
  font-size: 0.875rem;
  margin-bottom: 0.75rem; /* 增加底部间距 */
}

.beian {
  color: white;
  font-size: 0.8rem; /* 移动端进一步减小字体 */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap; /* 允许换行 */
  gap: 5px;
  line-height: 1.5; /* 增加行高 */
  padding: 0 0.5rem; /* 增加内边距 */
}

.beian a {
  color: white;
  text-decoration: none;
}

.beian a:hover {
  text-decoration: underline;
}

.beian-icon {
  vertical-align: middle;
  height: 16px; /* 移动端减小图标大小 */
  display: inline-block;
  margin: 0 2px;
}

.separator {
  margin: 0 5px; /* 减小分隔符间距 */
  color: white;
}

/* 针对超小屏幕的优化 */
@media (max-width: 360px) {
  .footer-description {
    font-size: 0.9rem;
  }
  
  .footer-heading {
    font-size: 1rem;
  }
  
  .beian {
    font-size: 0.75rem;
  }
  
  .beian-icon {
    height: 14px;
  }
}

/* Font Awesome Icons */
.wechat-icon::before {
  content: "\f1d7";
  font-family: "Font Awesome 6 Brands";
  font-weight: 400;
  font-size: 1.25rem;
}

.weibo-icon::before {
  content: "\f18a";
  font-family: "Font Awesome 6 Brands";
  font-weight: 400;
  font-size: 1.25rem;
}

.linkedin-icon::before {
  content: "\f08c";
  font-family: "Font Awesome 6 Brands";
  font-weight: 400;
  font-size: 1.25rem;
}



</style>